import ButtonLoadingContent from '../../../../shared/Loading/ButtonLoadingContent';

const Toolbar = (props) => {
  return (
        <div className='flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between mb-4'>
            <h2 className="text-2xl font-bold text-gray-800 sm:text-3xl md:text-4xl">
                Preguntas frecuentes
            </h2>
            {props.isEditor && 
                <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
                    <button
                        onClick={() => {
                            props.handleAddQuestion()
                            props.setOpenId(props.questions.length + 1)
                        }}
                        className={`w-full sm:w-auto px-4 py-2 text-sm border border-transparent text-white rounded ${
                            props.loading
                                ? 'bg-purple-200 cursor-not-allowed'
                                : 'bg-personalized hover:bg-gray-100 hover:text-personalized hover:border-personalized'
                            }`}
                        >
                            <ButtonLoadingContent loading={props.loading}>
                                + Agregar pregunta
                            </ButtonLoadingContent>
                    </button>
                    <button className={`w-full sm:w-auto px-4 py-2 text-sm border border-transparent text-white rounded ${
                            props.loading || props.questions.some(q => !q.Question?.trim() || !q.Answer?.trim())
                                ? 'bg-purple-200 cursor-not-allowed'
                                : 'bg-personalized hover:bg-gray-100 hover:text-personalized hover:border-personalized'
                            }`
                        }
                        onClick={() => props.saveChangeQuestions()}
                    >
                        <ButtonLoadingContent loading={props.loading}>
                            Guardar cambios de preguntas
                        </ButtonLoadingContent>
                    </button>
                </div>
            }
        </div>
    );
};

export default Toolbar;
